import { Flex, Icon, Text } from '@/ui';

type Props = {
  label: string;
  isActive: boolean;
  onClick: () => void;
};

// The "add a workspace" affordance at the foot of the accounts list. Dashed
// rather than solid so it reads as a slot to fill rather than an account the
// user already has.
export const CreateOrganizationItem = ({ label, isActive, onClick }: Props) => (
  <Flex
    _hover={{ bg: 'gray.200' }}
    align="center"
    as="button"
    bg={isActive ? 'gray.200' : 'transparent'}
    borderColor="gray.300"
    borderRadius="md"
    borderStyle="dashed"
    borderWidth="1px"
    gap="3"
    px="3"
    py="2.5"
    textAlign="left"
    type="button"
    w="100%"
    onClick={onClick}
  >
    <Flex
      align="center"
      bg="white"
      borderColor="gray.200"
      borderRadius="md"
      borderWidth="1px"
      boxSize="9"
      flexShrink={0}
      justify="center"
    >
      <Icon icon="Plus" size="4" />
    </Flex>
    <Text fontSize="sm" fontWeight="semibold" noOfLines={1}>
      {label}
    </Text>
  </Flex>
);
